import React from 'react';
import PropTypes from 'prop-types';

import InfiniteScroll from 'react-infinite-scroller';

import api from 'api';

import LoadSpinner from 'components/LoadSpinner';
import ContactCard from 'components/ContactsList/ContactCard';

class ContactsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contacts: [],
      hasMoreItems: true,
      isLoading: false,
    };
    this.fetchContacts = this.fetchContacts.bind(this);
  }

  async fetchContacts(page) {
    this.setState({ isLoading: true });

    const { data } = await api.searchAddresses({ page, page_size: 50 });
    if (data) {
      this.setState((prevState) => ({
        hasMoreItems: !!data.next,
        contacts: [...prevState.contacts, ...data.results],
      }));
    }

    this.setState({ isLoading: false });
  }

  render() {
    const { onClickEditAddress, t, onClickStartWithAddress } = this.props;
    const { contacts, hasMoreItems, isLoading } = this.state;
    const uniqueContactIds = Array.from(new Set(contacts.map((c) => c.id)));
    const contactsToShow = uniqueContactIds.map((id) =>
      contacts.find((c) => c.id === id)
    );

    return (
      <InfiniteScroll
        pageStart={0}
        loadMore={this.fetchContacts}
        useWindow={false}
        hasMore={!isLoading && hasMoreItems}
        loader={isLoading && <LoadSpinner size="12" key={0} />}
        threshold={10}
      >
        {contactsToShow.map((address, index) => (
          <ContactCard
            contact={address}
            isFirst={index === 0}
            key={address.id}
            onClick={() => onClickEditAddress(address)}
            onClickStartWithAddress={onClickStartWithAddress}
            t={t}
          />
        ))}
      </InfiniteScroll>
    );
  }
}

ContactsList.propTypes = {
  onClickContact: PropTypes.func,
  onClickEdit: PropTypes.func,
  t: PropTypes.func,
};

ContactsList.defaultProps = {
  onClickContact: () => ({}),
  t: (t) => t,
  onClickEdit: () => ({}),
};

export default ContactsList;
